import { Typography } from "@material-ui/core";
import { useState } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import {
	AddTable,
	DayTimeSelection,
	MaxCapacityTable,
} from "./components/maxCapacity";
import { useDaysOffStyles } from "./components/daysOffTable/daysOffStyles";
import DaysOffTab from "./components/daysOffTable/daysOffTab";
import DaysOffTable from "./components/daysOffTable/daysOffTable";
import TimeSlotTab from "./components/timeSlot/timeSlot";
import { FeaturesFilter } from "./components/featuresFilter";
import MaxCapacity from "./components/maxCapacity/maxCapacity";
import { Helmet } from "react-helmet";
import { getTranslation } from "../../heplers/translationHelper";
import EmailTab from "./components/email/emailTab";
import IframeTab from "./components/iframe/iframe";
import MyRestaurant from "./components/myRestaurant/myRestaurant";
import TablePlacement from "../common/tablePlacement/tablePlacement";
import { useSelector } from "react-redux";
import BlockServicesTab from "./components/blockServices/BlockServicesTab";

export const TableManagement = () => {
    const classes = useDaysOffStyles();
    const history = useHistory();
    const params = useParams();
    const selectedTab = params.tab || "myRestaurant";
    const userRole = useSelector((state) => state.auth?.user?.roles);
    const handleChange = (tab) => {
        // setSelectedTab(tab)
        history.push(`/${userRole}/settings/${tab}`);
    };
    return (
        <>
            <Helmet>
                <title>{getTranslation("Settings", "Settings", "Settings")}</title>
            </Helmet>
            <FeaturesFilter selectedTab={selectedTab} setSelectedTab={handleChange} userRole={userRole} />
            {selectedTab === "myRestaurant" && <MyRestaurant />}
            {/* {selectedTab === "maxCapacity" && <MaxCapacity />} */}
            {selectedTab === "tableplacement" && <TablePlacement />}
            {selectedTab === "daysOff" && <DaysOffTab />}
            {selectedTab === "timeSlots" && <TimeSlotTab />}
			{selectedTab === "email" && <EmailTab />}
            {selectedTab === "iframe" && <IframeTab />}
            {selectedTab === "blockServices" && <BlockServicesTab />}
            {/* <TablePlacement/> */}
        </>
    );
};